import { QueryObserverResult, useQuery } from '@tanstack/react-query';

import {
  API_QUERY_KEYS,
  getResponseTypes,
  GetResponseTypesResponse,
  QueryDefaults,
} from 'api';

export const useResponseTypes = (): QueryObserverResult<GetResponseTypesResponse> =>
  useQuery([API_QUERY_KEYS.getResponseTypes], getResponseTypes, QueryDefaults);
